/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {
  useCallback,
  useRef
} from 'react';
import {useDispatch} from 'react-redux';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';
import {CellMenu} from '@ion/dls/src/components/grid/CellMenu';
import {CellMenuItem} from '@ion/dls/src/components/grid/CellMenuItem';
import {ViewRecordIcon} from '@ion/dls/src/icons/ViewRecordIcon';
import {IconSize} from '@ion/dls/src/types/types';
import {viewDeviceEvent} from './state';

// defines the event row editor prop definitions ...
export interface EventRowEditorTypes {
  event: GenericObject;
}

const Icon = React.memo(() => (
  <ViewRecordIcon size={IconSize.medium} />
));

/**
 * Defines the EventRowEditor component. This component contains the cell actions
 * for the event grid.
 *
 * ```typescript
 *
 *   import {EventRowEditor} from './EventRowEditor';
 *
 *   <EventRowEditor .../>
 *
 * ```
 */
export const EventRowEditor = ({event}: EventRowEditorTypes) => {
  const dispatch    = useDispatch();
  const cellMenuRef = useRef(null);

  const closeMenu = useCallback(() => {
    cellMenuRef.current.closeCellMenu(cellMenuRef.current, true);
  }, []);

  const viewEventDetails = useCallback(() => {
    dispatch(viewDeviceEvent(event));
    closeMenu();
  }, [dispatch]);

  return (
    <>
      <CellMenu ref={cellMenuRef} menuItems={
        <div>
          <CellMenuItem icon={<Icon />}
            onClick={viewEventDetails}
            label={translate('admin-devices:view.events.grid.view')} />
        </div>
      } />
    </>
  );
};
